/* eslint-disable import/no-default-export */
export interface Tip {
  id: string;
  bgcolor: string;
  imgUrl1x: string;
  imgUrl2x: string;
  langs?: string[];
  url: string;
}

const tips: Tip[] = [
  {
    id: 'guide-1',
    bgcolor: '#F0AD83',
    imgUrl1x: require('images/tips/info-image-04@1x.png'),
    imgUrl2x: require('images/tips/info-image-04@2x.png'),
    url:
      'https://trello.com/guide?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=guide',
  },
  {
    id: 'power-ups-1',
    bgcolor: '#468EC5',
    imgUrl1x: require('images/tips/info-image-03@1x.png'),
    imgUrl2x: require('images/tips/info-image-03@2x.png'),
    url:
      'https://trello.com/power-ups?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=power-ups',
  },
  {
    id: 'playbooks-1',
    bgcolor: '#2A3161',
    imgUrl1x: require('images/tips/info-image-02@1x.png'),
    imgUrl2x: require('images/tips/info-image-02@2x.png'),
    url:
      'https://trello.com/teams?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=playbooks',
  },
  {
    id: 'inspiration-1',
    bgcolor: '#0E6AB3',
    imgUrl1x: require('images/tips/info-image-01@1x.png'),
    imgUrl2x: require('images/tips/info-image-01@2x.png'),
    langs: ['en-US', 'en-GB', 'en-AU', 'fr', 'pt-BR'],
    url:
      'https://trello.com/inspiration?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=inspiration',
  },
];

export default tips;



// WEBPACK FOOTER //
// ./app/common/data/tips.ts